<div class="gip-modal">
    <app-grid-template [columns]="PersonIDGrid" [urlString]="urlString" [clearFiltersButton]="true" (action)="action($event)" [selectedKey]="selectedKey" [groupName]="groupName" [selectedSingleRow]="selectedRow" [defaultFilter]="defaultFilter"></app-grid-template>

    <button mat-raised-button class="StandardButton" (click)="close()">
        {{"btn_close" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "SHORT_TEXT" : "Common"}}
    </button>

    <button mat-raised-button class="StandardButton" [mat-dialog-close]="selectedRows">
        {{"btn_select" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "SHORT_TEXT" : "Common"}}
    </button>
</div>